import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { LanguageService } from '@core/services/language.service';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';
import { formatDateLocalized } from '@shared/utils/date-utils';

import { type DaySwitcherConfig } from './day-switcher.types';

@Component({
  selector: 'app-day-switcher',
  templateUrl: './day-switcher.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class DaySwitcher {
  private readonly languageService = inject(LanguageService);

  readonly config = input.required<DaySwitcherConfig>();

  readonly action = output<DynamicAction>();

  protected readonly formattedDate = computed(() => {
    const date = new Date(this.config().date);
    return formatDateLocalized(date, 'ccc, LLL d', this.languageService.shortLanguage());
  });

  protected onPrevious(): void {
    this.action.emit({ id: 'previous' });
  }

  protected onNext(): void {
    this.action.emit({ id: 'next' });
  }

  protected onDateClick(): void {
    this.action.emit({ id: 'dateClick' });
  }
}
